import { getRoot, types } from 'mobx-state-tree'
import { ContentObject, RootModel } from '@shared/data-access'

export const MODEL_NAME = 'Campaign'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    campaignName: types.string,
    campaignMeta: types.maybeNull(ContentObject),
  })
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))
